module.exports = __webpack_public_path__ + "static/img/faq-2.adf56af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/faq-2.png
// module id = srrP
// module chunks = 4